<template>
	<v-list class="notes-list">
		<NoteItem
			v-for="resourceItem in resourcesItems"
			:key="resourceItem.upload_id"
			:resourceItem="resourceItem"
		/>
	</v-list>
</template>

<script>
import NoteItem from '@/components/Profile/NoteItem.vue'

export default {
	name: 'NoteList',
	components: {
		NoteItem
	},
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		}
	}
}
</script>

<style lang="scss">
.notes-list {
	padding: 0;
	background: transparent !important;
}
</style>
